//
//
//
//
//
//
//
//
//

export default {
  name: 'ShareBySms',
  props: {
    url: String,
    title: String,
    description: String,
  },
  data() {
    return {
      show: false,
      e: null,
    }
  },
  methods: {
    async open() {
      const ZERO = 0
      const data = {
        title: this.title,
        text: this.description,
        url: this.url,
      }
      if (
        (navigator.maxTouchPoints > ZERO ||
        navigator.msMaxTouchPoints > ZERO) &&
        navigator.canShare(data)
      ) {
        await navigator.share(data)
        return
      }
      this.copy()
    },
    close() {
      this.show = false
    },
    async copy() {
      try {
        await navigator.clipboard.writeText(this.url)
        this.$notify({
          type: 'success',
          title: `${this._('Скопійовано!')}`,
        })
      } catch (err) {
        console.log(err)
        this.$notify({
          type: 'error',
          title: `${this._('Виникла помилка')}`,
        })
        throw new Error('Oops, unable to copy')
      }
    },
  },
}
